import React from "react";
import { S3_URL_COLLECTION_BANNERS } from "../../../shared/utils/constants";
import ImageSlider from "../../../shared/ui/ImageSlider";

// The collection's own images from the API as a slider; nothing when it has none.
const CollectionBanner = ({ images }) => {
  const banners = (Array.isArray(images) ? images : []).filter(Boolean).map((imageName) => ({
    src: `${S3_URL_COLLECTION_BANNERS}${imageName}`,
    alt: "",
  }));
  return <ImageSlider banners={banners} />;
};

export default CollectionBanner;
